import { render, staticRenderFns } from "./SoftwareLogo.vue?vue&type=template&id=7847fe9b&scoped=true&"
import script from "./SoftwareLogo.vue?vue&type=script&lang=js&"
export * from "./SoftwareLogo.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareLogo.vue?vue&type=style&index=0&id=7847fe9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7847fe9b",
  null
  
)

export default component.exports